import { Table } from "semantic-ui-react";
import { formatRupees } from "../../../utils/money";

const pct = (v) => `${Number(v)}%`;

/* Every figure here is the server's. Headings are shown to the paisa and
   only the grand total is rounded, so the rows always add up. */
export default function BillTotals({ bill, paymentSummary }) {
  const s = paymentSummary;
  return (
    <Table compact definition unstackable size="small" style={{ maxWidth: 460, marginLeft: "auto" }}>
      <Table.Body>
        {bill.categoryTotals.map((c) => (
          <Table.Row key={c.name}>
            <Table.Cell>{c.name}</Table.Cell>
            <Table.Cell textAlign="right">{formatRupees(c.total)}</Table.Cell>
          </Table.Row>
        ))}
        <Table.Row>
          <Table.Cell>Amount before GST</Table.Cell>
          <Table.Cell textAlign="right">{formatRupees(bill.taxableTotal)}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>CGST{bill.isOfficial ? "" : ` (${pct(bill.cgstPercent)})`}</Table.Cell>
          <Table.Cell textAlign="right">{formatRupees(bill.cgstTotal)}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>SGST{bill.isOfficial ? "" : ` (${pct(bill.sgstPercent)})`}</Table.Cell>
          <Table.Cell textAlign="right">{formatRupees(bill.sgstTotal)}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Round off</Table.Cell>
          <Table.Cell textAlign="right">{formatRupees(bill.roundOff)}</Table.Cell>
        </Table.Row>
        <Table.Row style={{ fontSize: "1.25em" }}>
          <Table.Cell><strong>Bill total</strong></Table.Cell>
          <Table.Cell textAlign="right"><strong>{formatRupees(bill.grandTotal)}</strong></Table.Cell>
        </Table.Row>
        {s && (
          <>
            <Table.Row>
              <Table.Cell>Paid so far</Table.Cell>
              <Table.Cell textAlign="right">{formatRupees(s.netPaid)}</Table.Cell>
            </Table.Row>
            {Number(s.refundDue) > 0 ? (
              <Table.Row negative style={{ fontSize: "1.25em" }}>
                <Table.Cell><strong>To refund</strong></Table.Cell>
                <Table.Cell textAlign="right"><strong>{formatRupees(s.refundDue)}</strong></Table.Cell>
              </Table.Row>
            ) : (
              <Table.Row style={{ fontSize: "1.25em", background: "#21ba45", color: "#fff" }}>
                <Table.Cell style={{ background: "#21ba45", color: "#fff" }}>
                  <strong>{s.settled ? "Settled" : "Still to pay"}</strong>
                </Table.Cell>
                <Table.Cell textAlign="right" style={{ background: "#21ba45", color: "#fff" }}>
                  <strong>{formatRupees(s.balanceDue)}</strong>
                </Table.Cell>
              </Table.Row>
            )}
          </>
        )}
      </Table.Body>
    </Table>
  );
}
